import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import { ZoomProvider } from "./context/ZoomContext";
import { ThemeProvider } from "./context/ThemeContext";
import { SiteViewerProvider } from "./context/ViewerContext";
import HomePage from "./pages/Home";
import SearchPage from "./pages/Search";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import ForgotPasswordPage from "./pages/ForgotPassword";
import ProfilePage from "./pages/Profile";
import DevelopersPage from "./pages/Developers";
import HackSecretPage from "./pages/HackSecret";
import SettingsPage from "./pages/Settings";
import AboutPage from "./pages/About";
import AccountPage from "./pages/Account";
import PasswordsPage from "./pages/Passwords";
import HistoryPage from "./pages/History";
import DownloadsPage from "./pages/Downloads";
import BookmarksPage from "./pages/Bookmarks";
import TranslatePage from "./pages/Translate";
import CastPage from "./pages/Cast";
import SharePage from "./pages/Share";
import HelpPage from "./pages/Help";
import ContactPage from "./pages/Contact";
import DevToolsPage from "./pages/DevTools";
import OmniMailPage from "./pages/OmniMail";
import { OmniTubeIndex, OmniTubeWatch } from "./pages/OmniTube";
import OmniAIPage from "./pages/OmniAI";
import OmniDrivePage from "./pages/OmniDrive";
import OmniMapPage from "./pages/OmniMap";
import OmniStorePage from "./pages/OmniStore";
import AdminPage from "./pages/Admin";
import { AdManager } from "./components/AdManager";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <ZoomProvider>
          <AuthProvider>
            <BrowserRouter>
              <SiteViewerProvider>
                <AdManager />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/passwords" element={<PasswordsPage />} />
                  <Route path="/history" element={<HistoryPage />} />
                  <Route path="/downloads" element={<DownloadsPage />} />
                  <Route path="/bookmarks" element={<BookmarksPage />} />
                  <Route path="/translate" element={<TranslatePage />} />
                  <Route path="/cast" element={<CastPage />} />
                  <Route path="/share" element={<SharePage />} />
                  <Route path="/help" element={<HelpPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/devtools" element={<DevToolsPage />} />
                  <Route path="/mail" element={<OmniMailPage />} />
                  <Route path="/tube" element={<OmniTubeIndex />} />
                  <Route path="/tube/watch" element={<OmniTubeWatch />} />
                  <Route path="/ai" element={<OmniAIPage />} />
                  <Route path="/drive" element={<OmniDrivePage />} />
                  <Route path="/map" element={<OmniMapPage />} />
                  <Route path="/store" element={<OmniStorePage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/developers" element={<DevelopersPage />} />
                  <Route path="/h4ck" element={<HackSecretPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                </Routes>
              </SiteViewerProvider>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </ZoomProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
